function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7206 9.15918C13.7206 7.51916 14.1624 5.99869 14.9214 4.63936C14.5211 4.59778 14.1209 4.55879 13.7206 4.55879C6.15984 4.55879 0 10.7212 0 18.2794C0 25.8401 6.15984 32 13.7206 32C21.2813 32 27.4412 25.8401 27.4412 18.2794C27.4412 17.8791 27.3996 17.4789 27.3606 17.0786C26.0403 17.8375 24.4808 18.2794 22.8408 18.2794C17.8012 18.2794 13.7206 14.2014 13.7206 9.15918Z",
  fill: "#8E8B99"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.0026 9.15919C32.0026 4.08057 27.9221 0 22.8409 0C19.4412 0 16.4835 1.87914 14.8824 4.64198C21.5231 5.20078 26.8019 10.4821 27.3607 17.0812C30.1209 15.5218 32.0026 12.5614 32.0026 9.15919Z",
  fill: "#8E8B99"
});

var SvgIntegrationsIcon = function SvgIntegrationsIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIntegrationsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/integrationsIcon.4dee55e9.svg";
export { ForwardRef as ReactComponent };